import { decode } from 'html-entities';
import Model from '../api/model';
export function useSoftware() {
	const softwareLoading = ref( true );
	const manualsList = ref([]);
	const softwareList = ref([]);
	const firmwareList = ref([]);
	const getSoftwareList = ( params ) => new Promise(( resolve, reject ) => {
			softwareLoading.value = true;
			Model.software( params ).
				then(({ result, status }) => {
					if ( status === 'success' ) {
						for ( const key in result ) {
							if ( result[ key ] && Array.isArray( result[ key ])) {
								const element = result[ key ];
								element.forEach(( item ) => {
									item.name = decode( item.name );
									item.docName = decode( item.docName );
								});
							}
						}
						softwareList.value = result?.software;
						manualsList.value = Array.isArray( result?.document ) && result?.document.length > 0 ? result?.document : [];
						// const sortManualsList = resManualsList.sort(( a, b ) => ( b?.docName || b?.name ).localeCompare(( a?.docName || a?.name ), 'zh-Hans-CN', { sensitivity: 'accent' }));
						// manualsList.value = sortManualsList;
						firmwareList.value = result?.firmware || result?.fireware;
						softwareLoading.value = false;
						resolve();
					} else {
						softwareLoading.value = false;
						reject( result );
					}
				}).
				catch(( e ) => {
					softwareLoading.value = false;
					reject( e );
				});
		});
	return { softwareList, softwareLoading, manualsList, firmwareList, getSoftwareList };
}
